import type { FC, ReactNode } from 'react'
import type { ShellData } from '@/types'

import { Layout } from '@/components/generals/layout'
import { SiteHeader } from '@/components/store/site-header'
import { SiteFooter } from '@/components/store/site-footer'
import { CartDrawer } from '@/components/store/cart-drawer'
import { AssistantWidget } from '@/components/store/assistant-widget'

interface StoreLayoutProps {
    shell: ShellData
    children: ReactNode
    hideAssistant?: boolean
}

export const StoreLayout: FC<StoreLayoutProps> = ({ shell, children, hideAssistant }): ReactNode => {
    return (
        <Layout
            header={<SiteHeader shell={shell} />}
            footer={<SiteFooter shell={shell} />}
            after={(
                <>
                    <CartDrawer />
                    {!hideAssistant && <AssistantWidget shell={shell} />}
                </>
            )}
        >
            {children}
        </Layout>
    )
}
